import useOnClickOutside from '~/client/hooks/events/useOnClickOutside';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import useAgentData from '~/client/hooks/useAgentData';
import useShowClose from '~/client/hooks/useOpenClose';
import useSelectedFiltersStore from '../../GameList/store/useSelectedFiltersStore';

const useSortFilter = () => {
  const { sort, setSort } = useSelectedFiltersStore();
  const field = sort.name;

  const handleSelect = (item: SortOptions) => {
    if (item === sort.name) {
      return setSort({
        name: item,
        value: item === sort.name && sort.value === 1 ? -1 : 1,
      });
    }
    return setSort({ name: item, value: item === 'name' ? 1 : -1 });
  };

  const { isMobile } = useAgentData();
  const { isOpen, handleOpen, handleClose } = useShowClose();
  const { elementRef } = useOnClickOutside<HTMLDivElement>({
    handler: handleClose,
  });
  const sortByLabel = useTranslation('general.sort_by');
  const nameLabel = useTranslation(`casino.menu_item_${field}_order`);
  return {
    label: nameLabel,
    sortByLabel,
    elementRef,
    isOpen,
    handleSelect,
    handleOpen,
    selected: sort,
    isFullWidth: isMobile,
  };
};

export default useSortFilter;
